import React, { Component } from 'react'
import { Route, Redirect } from 'react-router-dom'
import { AuthContext } from '../../AuthContext'


class AuthenticatedRoute extends Component {

  render(){
    const { AuthUser} = this.context
    const { component: C, ...rest } = this.props
    return (
      <Route
      {...rest}
      render={props =>
        (AuthUser && AuthUser.is_authenticated())
          ? <C {...props} />
          : <Redirect
            to={`/login?redirect=${props.location.pathname}${props.location
              .search}`}
          />}
    />
    )
  }
}

AuthenticatedRoute.contextType = AuthContext

export default AuthenticatedRoute